import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Payment } from 'anchor-shared/lib/model/entity/payment';
import { StripePaymentDAO } from '../../../../../core/services/dao/stripePaymentDAO';
import { environment } from '../../../../../environments/environment';
import { CharterPaymentDAO } from '../../../../../core/services/dao/charterPaymentDAO';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { Observable } from 'rxjs/internal/Observable';
import { PaymentIntent } from '@stripe/stripe-js/types/api/payment-intents';
import { PaymentMethod } from '@stripe/stripe-js';
import { combineLatest } from 'rxjs';
import { AppMessagingService } from '../../../../../core/services/app-messaging.service';

@Component({
  selector: 'app-security-hold-postprocessing-dialog',
  templateUrl: './security-hold-postprocessing-dialog.component.html',
  styleUrls: ['./security-hold-postprocessing-dialog.component.scss'],
})
export class SecurityHoldPostprocessingDialogComponent implements OnInit {
  depositPayment: Payment;
  fullPayment: Payment;
  paymentToProcess: Payment;
  isRefund: boolean;
  processingAmount: string;
  charter: Charter;
  chargeDescription: string;
  paymentReady: boolean;
  paymentIntent: PaymentIntent;
  paymentMethods: PaymentMethod[];
  processButtonText: string;
  title: string;
  private holdProcessed: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<SecurityHoldPostprocessingDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      depositPayment: Payment;
      isRefund: boolean;
      charter: Charter;
      refundAmount: number;
      fullPayment: Payment;
    },
    private stripePaymentDAO: StripePaymentDAO,
    private charterPaymentDAO: CharterPaymentDAO,
    private appMessagingService: AppMessagingService,
  ) {
    this.paymentToProcess = this.depositPayment = this.data.depositPayment;
    this.isRefund = this.data.isRefund;
    this.charter = this.data.charter;
    if (this.data.refundAmount) {
      this.processingAmount = Math.abs(this.data.refundAmount).toFixed(2);
      this.paymentToProcess = this.fullPayment = this.data.fullPayment;
      this.processButtonText = 'Refund additional costs';
      this.title = 'Refund Additional Costs';
    } else {
      this.processButtonText = this.isRefund
        ? 'Refund Security Hold'
        : 'Charge Customer';
      this.title = this.isRefund ? 'Refund Deposit' : 'Charge payment Method';
    }
  }

  ngOnInit(): void {}

  disableProcessHoldButton(): boolean {
    if (this.processingAmount <= '0') {
      return true;
    } else if (!this.processingAmount) {
      return true;
    } else if (!this.isRefund && !this.chargeDescription) {
      return true;
    } else if (this.holdProcessed) {
      return true;
    } else if (
      parseFloat(this.processingAmount) >=
      parseFloat(this.paymentToProcess.amount)
    ) {
      return true;
    } else {
      return false;
    }
  }

  processHold() {
    this.holdProcessed = true;
    if (this.isRefund) {
      let paymentIntentIdToRefund;
      if (!this.data.refundAmount) {
        paymentIntentIdToRefund = this.depositPayment.paymentIntentId;
      } else {
        paymentIntentIdToRefund = this.fullPayment.paymentIntentId;
      }

      this.stripePaymentDAO
        .refundHold(paymentIntentIdToRefund, Number(this.processingAmount))
        .subscribe((data) => {
          if (data) {
            this.appMessagingService.openSnack(
              'Payment refunded successfully!',
            );
            this.dialogRef.close(true);
          } else {
            this.appMessagingService.openSnack(
              'An error occurred refunding the payment.',
            );
          }
        });
    } else {
      const createPaymentIntent =
        this.charterPaymentDAO.createAdminPaymentIntent(
          this.charter.id,
          this.charter.userId,
          this.processingAmount.toString(),
          `Charter ${this.charter.id} damage charge`,
          this.chargeDescription,
        );

      const obs: Observable<any>[] = [
        createPaymentIntent,
        this.listCustomerPaymentMethods(),
      ];

      const paymentIntentSub = combineLatest(obs).subscribe(
        ([paymentIntent$, paymentMethods$]) => {
          this.paymentReady = true;
          this.paymentIntent = paymentIntent$;
          this.paymentMethods = paymentMethods$.data;
        },
        (error) => {
          this.appMessagingService.openSnack(
            'An error occurred during payment processing. Please contact IT.',
          );
        },
      );
    }
  }

  listCustomerPaymentMethods(): Observable<PaymentMethodData> {
    return this.stripePaymentDAO.adminListCustomerPaymentMethods(
      this.charter.userId,
    );
  }

  goToStripePaymentIntent() {
    const intentId =
      this.data.refundAmount < 0
        ? this.fullPayment.paymentIntentId
        : this.depositPayment.paymentIntentId;

    let stripeUrl = `https://dashboard.stripe.com/payments/${intentId}`;
    if (!environment.production) {
      stripeUrl = `https://dashboard.stripe.com/test/payments/${intentId}`;
    }
    window.open(stripeUrl, '_blank');
  }

  closeDialog(paymentIntent?: PaymentIntent) {
    this.dialogRef.close(paymentIntent);
  }
}
